import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./LanguageModal.css";

function LanguageModal({
  show,
  handleClose,
  mode,
  language,
}) {
  const languageOptions = [
    { value: "English", label: "English" },
    { value: "Hindi", label: "Hindi" },
    { value: "Marathi", label: "Marathi" },
    { value: "French", label: "French" },
    { value: "German", label: "German" },
  ];

  const proficiencyOptions = [
    { value: "Beginner", label: "Beginner" },
    { value: "Intermediate", label: "Intermediate" },
    { value: "Professional", label: "Professional" },
    { value: "Native", label: "Native" },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedProficiency, setSelectedProficiency] = useState(null);

  const [read, setRead] = useState(false);
  const [write, setWrite] = useState(false);
  const [speak, setSpeak] = useState(false);

  useEffect(() => {
    if (mode === "edit" && language) {
      setSelectedLanguage({
        value: language.language,
        label: language.language,
      });

      setSelectedProficiency({
        value: language.proficiency,
        label: language.proficiency,
      });

      setRead(language.read);
      setWrite(language.write);
      setSpeak(language.speak);
    } else {
      setSelectedLanguage(null);
      setSelectedProficiency(null);
      setRead(false);
      setWrite(false);
      setSpeak(false);
    }
  }, [language, mode]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: 46,
      border: "1px solid #d8dce7",
      boxShadow: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const handleSave = () => {
    console.log({
      language: selectedLanguage,
      proficiency: selectedProficiency,
      read,
      write,
      speak,
    });

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal language-modal"
    >
      <Modal.Header className="language-modal__header">
        <Modal.Title>
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          {mode === "edit"
            ? "Edit language"
            : "Add language"}
        </Modal.Title>

        <button
          className="btn-close"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      <Modal.Body className="language-modal__body">
        <Form.Group className="mb-4">
          <Form.Label className="language-modal__label">
            Language <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={languageOptions}
            value={selectedLanguage}
            onChange={setSelectedLanguage}
            placeholder="Select value"
            styles={selectStyles}
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label className="language-modal__label">
            Proficiency <span className="text-danger">*</span>
          </Form.Label>

          <Select
            options={proficiencyOptions}
            value={selectedProficiency}
            onChange={setSelectedProficiency}
            placeholder="Select value"
            styles={selectStyles}
          />
        </Form.Group>

        <div className="language-modal__checkboxes">
          <Form.Check
            inline
            type="checkbox"
            label="Read"
            checked={read}
            onChange={(e) => setRead(e.target.checked)}
          />

          <Form.Check
            inline
            type="checkbox"
            label="Write"
            checked={write}
            onChange={(e) => setWrite(e.target.checked)}
          />

          <Form.Check
            inline
            type="checkbox"
            label="Speak"
            checked={speak}
            onChange={(e) => setSpeak(e.target.checked)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="language-modal__footer">
        {mode === "edit" ? (
          <Button
            variant="link"
            className="language-modal__delete"
          >
            Delete Language
          </Button>
        ) : (
          <div></div>
        )}

        <Button
          className="language-modal__save"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LanguageModal;